module.exports = __webpack_public_path__ + "img/buessiness_ky_h.3877bf6d.png";